export default __webpack_public_path__ + "static/ee-173b55ee3f175be6f7cb6491c088bbb0.svg";